import React from 'react'
import './Card.css'

// Custom components
import CTAbutton from '../CTAbutton'

export const Card = ({ cssClass, isLoading = false, titleSectionClass, titleClass, subtitleClass, imageClass, authorClass, title, subtitle, image, author, children, isSingleArticle, addressId }) => {
  
  if (isLoading) {
    return (
      <div className={`wordpay-demo__card ${cssClass}`}>
        <span className='wordpay-demo__card-placeholder-image'></span>
        <span className='wordpay-demo__card-line'></span>
        <span className='wordpay-demo__card-line'></span>
        <span className='wordpay-demo__card-line'></span>
        <span className='wordpay-demo__card-line'></span>
        <span className='wordpay-demo__card-line'></span>
      </div>
    )
  }
  
  return (
    <div className={`wordpay-demo__card ${cssClass}`}>
      <div className={titleSectionClass}>
        <h1 className={titleClass}>{title}</h1>
        <div className='wordpay-demo__card-image-container'>
          <img src={image} alt='' className={imageClass}></img>
        </div>
        <h3 className={authorClass}>{author}</h3>
        <p className={subtitleClass}>{subtitle}</p>
      </div>
      {children}
      {isSingleArticle === true && (
        <div className='wordpay-demo__article-footer'>
          <CTAbutton btn='Read more' addressId={addressId} />
        </div>
      )}
    </div>
  )
}